import { useMsal } from '@azure/msal-react';
import { useEffect } from 'react';
import { useTitleService } from '@scts/utilities';
import { useNavigate } from 'react-router-dom';

const LoginComponent = () => {
  useTitleService('Login: : Social Security Chamber');
  const { instance, accounts } = useMsal();
  const nav = useNavigate();

  const login = () => {
    instance.loginRedirect().catch((err) => {
      console.log('ERROR: ', err);
    });
  };

  useEffect(() => {
    if (accounts) {
      instance
        .handleRedirectPromise()
        .then((res) => {
          if (res) {
            //console.log('Logged in');
          } else {
            nav('/'); //get round bookmarking issue
          }
        })
        .catch((err) => console.log('Error: ', err));
    }
  }, [instance, accounts]);

  return (
    <>
      {accounts.length === 0 && (
        <div className="card login-wrapper">
          <div className="card-body login-body">
            <div className="d-flex flex-column ">
              <img
                src={'./assets/images/ssc-logo.png'}
                alt="Social Security Scotland logo"
                className="p-1 pb-2"
              />
              <div className="flex-column p-2 d-grid">
                <button
                  className="btn btn-primary"
                  autoFocus
                  onClick={() => login()}
                >
                  Click here to login
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LoginComponent;
